import { apiGet, apiPostJson, JsonValue, apiPostFormUrlEncoded, displayApiError, FormUrlEncodedBody, getApiErrorMessage, toLegacyAjaxError } from '@shared/api/apiClient';

type LegacyAbortableRequest = Promise<void> & {
    abort: () => LegacyAbortableRequest;
    readyState: number;
    status: number;
    statusText: string;
};

function createLegacyRequest<T>(
    request: Promise<T>,
    controller: AbortController,
    successCallback: (retData: T) => void,
    errorCallback: IErrorCallback,
): JQueryXHR {
    const abortable = request
        .then((retData) => {
            abortable.readyState = 4;
            abortable.status = 200;
            abortable.statusText = 'success';
            successCallback(retData);
        })
        .catch((error) => {
            const legacyError = toLegacyAjaxError(error);
            abortable.readyState = legacyError.readyState;
            abortable.status = legacyError.status;
            abortable.statusText = legacyError.statusText;
            errorCallback(legacyError);
        }) as LegacyAbortableRequest;

    abortable.readyState = 1;
    abortable.status = 0;
    abortable.statusText = '';
    abortable.abort = () => {
        controller.abort();
        abortable.readyState = 0;
        abortable.status = 0;
        abortable.statusText = 'abort';
        return abortable;
    };

    return abortable as unknown as JQueryXHR;
}

var BaseService: IServiceObject = {
    get: function (url: string, data: any, successCallback: (retData: any) => void, errorCallback: IErrorCallback) {
        var controller = new AbortController();
        return createLegacyRequest(
            apiGet(url, data as FormUrlEncodedBody | null, { signal: controller.signal }),
            controller,
            successCallback,
            errorCallback,
        );
    },

    post: function (url: string, data: any, successCallback: (retData: any) => void, errorCallback: IErrorCallback) {
        var controller = new AbortController();
        return createLegacyRequest(
            apiPostFormUrlEncoded(url, (data || {}) as FormUrlEncodedBody, { signal: controller.signal }),
            controller,
            successCallback,
            errorCallback,
        );
    },

    postJson: function (url: string, data: JsonValue, successCallback: (retData: any) => void, errorCallback: IErrorCallback) {
        const controller = new AbortController();
        return createLegacyRequest(apiPostJson(url, data, { signal: controller.signal }), controller, successCallback, errorCallback);
    },

    handleWebApiError(error: IAjaxErrorObject) {
        displayApiError(error);
    },

    parseError(error: IAjaxErrorObject) {
        return getApiErrorMessage(error);
    }
};

export default BaseService;